/*
 * @Author: 陶慧灵
 * @Date: 2022-10-21 09:20:20
 * @LastEditors: wenbei421 346972930@qq.com
 * @LastEditTime: 2022-10-28 13:04:22
 * @Descripttion:
 * @FilePath: \src\index-examine.ts
 */
import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class IcdTcmIndex {
  private static like = ['ID', 'NAME', 'SPELL_CODE', 'STROKE_CODE']
  /**
   *
   * @param category：分类,例如DICT_SEX、DICT_NATION
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static query(category: string, keys: string = ''): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query('IcdTcmIndex', category, escapeSpecialCharacters(keys))
    } else {
      return IndexExamine.queryByServer('IcdTcmIndex', category, keys, this.like, {})
    }
  }

  /**
   * 分页查询索引
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类,例如DICT_SEX、DICT_NATION
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = ''
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'IcdTcmIndex',
        pageIndex,
        pageSize,
        category,
        escapeSpecialCharacters(keys)
      )
    } else {
      return IndexExamine.pageByServer(
        'IcdTcmIndex',
        pageIndex,
        pageSize,
        category,
        keys,
        this.like,
        {}
      )
    }
  }
}
